import { isEqual } from 'lodash'

const prodDepRoles = ['business_analyst', 'designer', 'project_manager', 'qa', 'developer']

export default {
  computed: {
    _allUserRoles: {
      get: function () {
        return this.$store.getters.getRoles
      }
    },
    _prodDepUserRoles: {
      get: function () {
        return this._allUserRoles.filter(role => {
          return prodDepRoles.includes(role.name)
        })
      }
    },
    _UserInfo: {
      get: function () {
        return this.$store.getters.getUser
      }
    },
    _prodDepUsers () {
      return this.$store.getters.getAllUsers.filter(user => {
        return user.roles.some(role =>
          prodDepRoles.includes(role.name)
        )
      })
    },
    _isAdmin () {
      return (
        this.$store.getters.getCurrentUserRole.indexOf('administrator') > -1
      )
    },
    _isUnitManager () {
      return this.$store.getters.getCurrentUserRole.indexOf('UnitManager') > -1
    },
    _isProjectManager () {
      return (
        this.$store.getters.getCurrentUserRole.indexOf('ProjectManager') > -1
      )
    },
    _isQA () {
      return this.$store.getters.getCurrentUserRole.indexOf('QA') > -1
    },
    _isAnother () {
      return this.$store.getters.getCurrentUserRole.indexOf('Another') > -1
    }
  },
  methods: {
    _getPartnerRelatedUsers (partnerId) {
      return this.$store.getters.getAllUsers.filter(user => {
        return user.partner_id === partnerId
      })
    },
    _removeProperty (prop) {
      return ({ [prop]: _, ...rest }) => rest
    },
    $can (permissionName) {
      let Permission = this.$store.getters.getPermission || ''
      return Permission.indexOf(permissionName) !== -1
    },
    fromDateToUTC (date, format = 'YYYY-MM-DD') {
      return this.$moment.utc(date, format)
    },
    _toIsoStringTime (time) {
      return this.$moment(time).toISOString()
    },
    _toLocalTime (time, format = 'YYYY-MM-DD', def = null) {
      if (this.$moment(time).isValid()) {
        return this.$moment(time).format(format)
      }
      return def
    },
    _localNowTime (format = 'YYYY-MM-DD') {
      return this.$moment().format(format)
    },
    async _toggleDataPageLoading (func) {
      this.isDataPageLoading = true
      return func().catch(error => {
        console.log('error', error)
        const errors = Object.values(error.response.data.errors)
        for (var i = 0; i < errors.length; i++) {
          this.$snotify.error(
            errors[i][0],
            'Error',
            this.$store.state.snotify
          )
        }
      }).finally(() => {
        this.isDataPageLoading = false
      })
    },
    _setRouteByFields (fields) {
      const setQuery = {}

      for (let item in fields) {
        if (Array.isArray(fields[item].value)) {
          fields[item].value.forEach((element, index) => {
            setQuery[item + index] = element.id.toString()
          })
          continue
        }

        if (Object.prototype.toString.call(fields[item].value) === '[object Date]') {
          setQuery[item] = this._toLocalTime(fields[item].value)
          continue
        }

        setQuery[item] = fields[item].value.toString()
      }

      const isSameParams = isEqual(this.$route.query, setQuery)

      if (isSameParams) return

      this.$router.replace({ query: setQuery })
    },
    errorNotifications (error) {
      const errors = Object.values(error.response.data.errors)
      for (var i = 0; i < errors.length; i++) {
        this.$snotify.error(
          errors[i][0],
          'Error',
          this.$store.state.snotify
        )
      }
    },
    fileToBase64 (file) {
      return new Promise(function (resolve, reject) {
        let reader = new FileReader()
        reader.onload = function (event) {
          let base64String = event.target.result
          resolve(base64String)
        }
        reader.onerror = function (error) {
          reject(error)
        }
        reader.readAsDataURL(file)
      })
    }
  }
}
